import { CheckCircle, Info, Warning } from "@phosphor-icons/react";
import clsx from "clsx";
import React from "react";

type HelperTextProps = {
  message: string;
  icon?: React.ReactNode;
  status?: "default" | "info" | "error" | "success";
};

const statusIcons: any = {
  default: null,
  error: <Warning weight="fill" />,
  success: <CheckCircle weight="fill" />,
  info: <Info weight="fill" />,
};

const getFormHelperText = (
  { message, icon, status = "default" }: HelperTextProps,
  size: string,
) => {
  return (
    <>
      {icon || statusIcons[status] ? (
        <span
          className={clsx("ox-reset ox-FormHelperTextIcon")}
          data-size={size}
        >
          {icon || statusIcons[status]}
        </span>
      ) : null}
      <span className="">{message}</span>
    </>
  );
};

export default getFormHelperText;
export type { HelperTextProps };
